import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { Box, Paper, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { LockerPng, Nepalbanklimited } from '../../components/utility/ImgNIcons';
import { Controller, useForm } from "react-hook-form";
import { LoginSchema } from '../../components/utility/yupValidation/LoginValidation';
import { yupResolver } from "@hookform/resolvers/yup";
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import { toast } from 'react-toastify';
import { useCallback, useEffect, useState } from 'react';
import '../../index.css'

const LoginContainer = styled(Box)`
    height: 100%;
    width:100%;
    min-height: 100vh; margin: 0px;
    position: relative;
    background: linear-gradient(287.34deg, #3150A1 0.05%, #85B4E1 169.84%), #FFFFFF;
    display:flex;
    align-items:center;
    justify-content:center
`;
const LoginCard = styled(Paper)`
    background:white;
    width:35%;
    height:30%;
    color:black;
    padding:40px 50px 24px ;
    border-radius:12px
`
export default function Login() {
    const navigate = useNavigate();
    const { add } = useCrudForm()
    const [isLoading, setIsLoading] = useState(false)

    const { handleSubmit, control, formState: { errors } } = useForm({
        defaultValues: {
            username: '',
            password: ''
        },
        resolver: yupResolver(LoginSchema)
    });


    const onSubmit = (values: any) => {
        setIsLoading(true)
        add({
            values,
            onSuccess: (data: any) => {
                toast.success(data.message, { style: { background: '#3150A1', } })
                localStorage.setItem('token', data.data);
                navigate("/");
                setIsLoading(false)
            },
            onError: (error: any) => {
                toast.warn(error)
                setIsLoading(false)
            },
            endpoints: endpoints.login.post
        })
    }

    const loginCheck = useCallback(
        async () => {
            try {
                if (localStorage.getItem('token')) {
                    navigate("/")
                }
            } catch (error) {
            }
        }, [navigate]
    );

    useEffect(() => {
        loginCheck();
        setIsLoading(false)
    }, [loginCheck]);

    return (
        <LoginContainer>
            <LoginCard>
                <Box >
                    <Box sx={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", height: '48px' }}>
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", minWidth: "50%", height: '100%' }}>
                            <img src={LockerPng} alt="locker" style={{ width: "30px", height: "30px" }} />
                            <Typography variant="h5" component="h2" fontWeight="bold">
                                Locker{" "}
                                <Typography fontWeight="bold" variant="h5" component="span" sx={{ color: "#3150A1" }}>System</Typography>
                            </Typography>
                        </Box>

                        <Box sx={{ width: "2px", height: "90%", background: "black", margin: '0px 12px' }}></Box>

                        <Box sx={{ width: "100%" }}>
                            <img src={Nepalbanklimited} alt="NRB" style={{ width: "100%", height: '48px ', objectFit: 'contain' }} />
                        </Box>
                    </Box>

                    <Box sx={{ marginTop: "24px" }}>
                        <Typography variant="h5" component="h5" textAlign={'center'} marginBottom={'12px'}>
                            User  Login
                        </Typography>
                        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                            <Controller
                                name={"username"}
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            id="username"
                                            label="Username"
                                            name="username"
                                            onChange={onChange}
                                            value={value}
                                            size='small'
                                            error={errors.username && Boolean(errors.username.message)}
                                            helperText={errors.username ? `${errors.username.message}` : ""}
                                        />
                                    </>


                                )}
                            />

                            <Controller
                                name={"password"}
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <>
                                        <TextField
                                            type='password'
                                            margin="normal"
                                            fullWidth
                                            id="password"
                                            label="Password"
                                            name="password"
                                            autoComplete="password"
                                            onChange={onChange}
                                            value={value}
                                            size='small'
                                            error={errors.password && Boolean(errors.password.message)}
                                            helperText={errors.password ? `${errors.password.message}` : ""}

                                        />


                                    </>


                                )}
                            />

                            <LoadingButton
                                fullWidth
                                loading={isLoading}
                                type='submit'
                                variant='contained'
                                sx={{ mt: 2, mb: 2, padding: 1 }}
                            >
                                Login
                            </LoadingButton>
                        </Box>
                    </Box>
                </Box>
            </LoginCard>
        </LoginContainer>
    )
}
